import React from 'react';
export function ProblemSection() {
  return <section className="mb-16" data-id="element-44">
      <p className="text-lg mb-6" data-id="element-45">For years, I felt stuck in survival mode.</p>
      <p className="text-lg mb-6" data-id="element-46">
        Even after therapy... after mindset work... after years of trying to
        "heal"... my body still felt tense, wired, and on edge.
      </p>
      <p className="text-lg mb-6" data-id="element-47">
        Some days I'd feel frozen — like I couldn't connect to my body at all.
      </p>
      <p className="text-lg mb-6" data-id="element-48">
        Other days the anxiety would spike out of nowhere.
      </p>
      <p className="text-lg mb-6" data-id="element-49">
        And deep down, there was this constant sense of exhaustion — as if my
        body had been fighting a battle I couldn't see.
      </p>
      <p className="text-lg mb-6" data-id="element-50">
        I didn't understand why… until I learned this:
      </p>
      <div className="bg-gray-100 p-6 rounded-lg mb-8" data-id="element-51">
        <p className="text-2xl text-center font-semibold text-gray-700" data-id="element-52">
          When you've been through chronic stress or trauma, your nervous system
          can get stuck in survival mode — long after the original danger is
          gone.
        </p>
      </div>
      <div className="mb-8" data-id="element-53">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wLEv45hw9jnaQ2SNH4UkHc/17cef8e-2885-4324-66a2-30e65137f44_fibromyalgiaNervePainBrain-1067733668-770x553_jpg_%281%29.webp" alt="Diagram showing nervous system connections" className="w-full rounded-lg" data-id="element-54" />
      </div>
      <p className="text-lg mb-6" data-id="element-55">
        Your body isn't doing this to sabotage you.
      </p>
      <p className="text-lg mb-6" data-id="element-56">It's trying to protect you — even now.</p>
    </section>;
}